module.exports = {"everyPageNum":20,"refreshTime":20000,"refreshTimeDesc":"refreshTime is in milliseconds"}


//////////////////
// WEBPACK FOOTER
// ./static/config.json
// module id = IuJc
// module chunks = 0